import {NgModule} from '@angular/core'
import {CommonModule} from '@angular/common'
import {HomePageContentComponent} from './home-page-content.component'
import {HowItWorksSectionModule} from '../how-it-works-section/how-it-works-section.module'
import {IndustrySectionModule} from '../industry-section/industry-section.module'
import {InspirationSectionModule} from '../inspiration-section/inspiration-section.module'
import {PartnersModule} from '../../../../craft/partners/partners.module'
import {PromotionalBannerSectionModule} from '../promotional-banner-section/promotional-banner-section.module'
import {ReviewsSectionModule} from '../reviews-section/reviews-section.module'
import {ServicesSectionModule} from '../services-section/services-section.module'
import {SupportSectionModule} from '../support-section/support-section.module'
import {KnowledgeSectionComponent} from '../knowledge-section/knowledge-section.component'
import {PresentationSectionComponent} from '../../presentation-section/presentation-section.component'

@NgModule({
  declarations: [HomePageContentComponent],
  imports: [
    CommonModule,
    HowItWorksSectionModule,
    IndustrySectionModule,
    InspirationSectionModule,
    PartnersModule,
    PromotionalBannerSectionModule,
    ReviewsSectionModule,
    ServicesSectionModule,
    SupportSectionModule,
    KnowledgeSectionComponent,
    PresentationSectionComponent,
  ],
  exports: [HomePageContentComponent],
})
export class HomePageContentModule {}
